// Reemplazo de Modal.confirm() de antd.
// API imperativa: confirm({ title, content, okText, cancelText, danger, onOk }).
// Requiere <ConfirmHost/> montado una vez en el shell global de la app.

let idSeq = 0;
let listener = null;

export function confirm(options) {
  if (!listener) {
    // eslint-disable-next-line no-console
    console.warn("confirm(): ConfirmHost no está montado todavía.");
    return;
  }
  listener({ id: ++idSeq, ...options });
}

export function registerConfirmHost(fn) {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}
